import { Injectable } from '@angular/core';
import { MILL_SECONDS } from 'common/constant/general';
import { Logger } from 'common/utility/logger/logger';
import { NgxSpinnerService, Size } from 'ngx-spinner';
import { SpinnerSizes } from './spinner/spinner-size';
import { SpinnerTypes } from './spinner/spinner-type';

const MAX_TIMEOUT = 60;
const SkippedStackLayers = ['LoadingService', 'loading@']
/** 
 * Provides a Spinner modal for multiple concurrent events waiting to complete. 
 */
@Injectable({ providedIn: 'root' })
export class LoadingService {
  private static numberRequests: number = 0;
  private static timeout: number = 0;
  private static intervalID: number = 0;

  constructor(
    private spinnerService: NgxSpinnerService
  ) { }

  public get spinnerType(): string {
    return SpinnerTypes.BallClipRotate;
  } // get spinnerType

  public get spinnerSize(): Size {
    return SpinnerSizes.Large
  } // get spinnerSize

  public loading(): void {
    LoadingService.numberRequests++;
    LoadingService.timeout = MAX_TIMEOUT;
    Logger.debug(`Load spinner requested by: ${this.getCallingFunction('loading')}`)

    this.spinnerService.show();

    if (!LoadingService.intervalID) {
      LoadingService.intervalID = window.setInterval(() => {
        if (LoadingService.timeout && !--LoadingService.timeout) {
          this.complete()
        }
      }, MILL_SECONDS)
    }
  } // loading()

  public loaded(): void {
    Logger.debug(`Load spinner request completed for: ${this.getCallingFunction('loaded')}`)

    if (LoadingService.numberRequests > 0 && !--LoadingService.numberRequests) {
      this.complete();
    }
  } // loaded()

  private complete(): void {
    LoadingService.numberRequests = 0;
    LoadingService.intervalID;
    this.spinnerService.hide();
    window.clearInterval(LoadingService.intervalID)
    LoadingService.intervalID = 0;
  } // complete()

  private getCallingFunction(skip: string): string | undefined {
    return Logger.getCallingFunction(['LoadingService', 'getCallingFunction', `${skip}@`])
  }

} // Class LoadingService
